/**
 * Console guard — silences all console output in production for non-admin users.
 * This module MUST be imported first in main.js (before any other app modules).
 *
 * It has zero dependencies so it evaluates before anything else in the module graph.
 * The admin status is toggled later by the auth store via setConsoleAdmin().
 */

const isProd = import.meta.env.PROD

// Store originals before any override
const _log = console.log.bind(console)
const _info = console.info.bind(console)
const _warn = console.warn.bind(console)
const _error = console.error.bind(console)
const _debug = console.debug.bind(console)

export const originalConsole = { log: _log, info: _info, warn: _warn, error: _error, debug: _debug }

let isAdmin = false

export function setConsoleAdmin(value) {
  isAdmin = value === true
}

if (isProd) {
  const gated = (fn) =>
    function (...args) {
      if (isAdmin) fn(...args)
    }

  console.log = gated(_log)
  console.info = gated(_info)
  console.warn = gated(_warn)
  console.error = gated(_error)
  console.debug = () => {}
}
